import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog } from '@knockrentals/knock-shared-web-v2';
import { makeCss } from '../../make-css';

export const DEFAULT_TERTIARY_BUTTON_TEXT = 'Cancel';

const useCss = makeCss({
  actions: {
    justifyContent: 'space-between',
  },
  secondaryButton: {
    marginRight: '16px',
  },
});

const FeatureDialogActions = ({
  isPrimaryButtonDisabled,
  primaryButtonOnClick,
  primaryButtonText,
  secondaryButtonOnClick,
  secondaryButtonText,
  tertiaryButtonOnClick,
  tertiaryButtonText = DEFAULT_TERTIARY_BUTTON_TEXT,
}) => {
  const css = useCss();

  const isPrimaryButtonVisible = primaryButtonOnClick && primaryButtonText;
  const isSecondaryButtonVisible =
    secondaryButtonOnClick && secondaryButtonText;
  const isTertiaryButtonVisible = tertiaryButtonOnClick && tertiaryButtonText;

  return (
    <Dialog.Actions css={css.actions}>
      <div>
        {isTertiaryButtonVisible && (
          <Button onClick={tertiaryButtonOnClick} variant="text">
            {tertiaryButtonText}
          </Button>
        )}
      </div>

      <div>
        {isSecondaryButtonVisible && (
          <Button
            css={css.secondaryButton}
            onClick={secondaryButtonOnClick}
            variant="outlined"
          >
            {secondaryButtonText}
          </Button>
        )}

        {isPrimaryButtonVisible && (
          <Button
            disabled={isPrimaryButtonDisabled}
            onClick={primaryButtonOnClick}
          >
            {primaryButtonText}
          </Button>
        )}
      </div>
    </Dialog.Actions>
  );
};

FeatureDialogActions.propTypes = {
  isPrimaryButtonDisabled: PropTypes.bool,
  primaryButtonText: PropTypes.string,
  primaryButtonOnClick: PropTypes.func,
  secondaryButtonText: PropTypes.string,
  secondaryButtonOnClick: PropTypes.func,
  tertiaryButtonText: PropTypes.string,
  tertiaryButtonOnClick: PropTypes.func,
};

export default FeatureDialogActions;
